// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".headline-hidden .headline_aligner,.headline-hidden.headline_inner:after,.headline-hidden .headline_text{display:none!important}", ""]);
// Exports
module.exports = exports;
